
export default {
    created() {
        if (this.$organization.sso) {  // 如果设置的是sso 那么就直接跳转连管理员输入都不显示
            if (!this.$route.query.ticket && !this.$route.query.code ) { // read user info
                if (this.$route.query.admin) {
                    this.admin_login=true;
                    this.ready = true;
                } else {
                    this.$nextTick(() => {
                        this.jumpToSSO();
                    });
                }
            }
        }
    },
    mounted() {
        const vm=this;
        if (!this.oauth && !this.$organization.sso) this.admin_login=true;
        if (this.$organization.oauth || this.$organization.sso) { // 这是显示管理员界面+单点登录界面
            if (this.$route.query.ticket ) { // read user info
                this.$api('SSO' + '?ticket=' + this.$route.query.ticket, null).then(res => {
                    if (res.data.success) {
                        vm.setUserInfo(res.data.data);
                        vm.jumpBack();
                    } else {
                        vm.$messageBox.error('错误的SSO返回信息,重新登录',null,()=>{
                            window.location.href = this.$organization.sso;
                        });
                    }
                });
            } else if (this.$route.query.code ){ // && this.$route.query.state && this.$route.query.state === 'zoom') {
                this.$api('SSO', {code: this.$route.query.code,state:this.$route.query.state,_t:this.$route.query._t},1).then(res => {
                    if (res.data.success) {
                        if (res.data.data.error) {
                            this.show_login_error = true;
                            this.error_message = res.data.data.message;
                        } else {
                            vm.setUserInfo(res.data.data);
                            vm.jumpBack();
                        }
                    } else {
                        this.$messageBox.error(res.data.text,null,()=>{
                            this.jumpToSignIn()
                        })
                    }
                }).catch(()=>{
                    this.ready = true;
                });
            } else if (this.$route.query.from === 'portal') {
                vm.jumpToOAuth2();
            } else if (this.sjtu_app) {
                //交大的app交我办进来就直接跳转
                vm.jumpToOAuth2();
            }else {
                this.ready = true;
            }
        } else {
            this.ready = true;
        }
    },
    computed: {
        oauth(){
            return !!this.$organization.oauth;
        },
    },
    methods: {
        jumpToOAuth2() {
            const return_url = this.$organization.signin_url;
            window.location.href = this.$organization.oauth
                + encodeURIComponent(return_url);
        },
        jumpToSSO() {
            const return_url = this.$organization.signin_url;
            let sso = this.$organization.sso;
            if (this.$route.query._t) {
                sso = sso.replace('zoom',encodeURIComponent(this.$route.query._t));
            }
            window.location.href = sso + encodeURIComponent(return_url);
        },
        jumpToSignIn(){
            this.$router.push('/sign-in');
            this.show_login_error = false;
            this.ready = true;
        },
        jumpBack(){
            const return_url = '/';
            const url = this.$route.query.state?decodeURIComponent(this.$route.query.state):return_url;
            this.$router.replace(url);
        }
    },
}
